import { useEffect, useState } from "react";
import { getTenantVerification } from "../services/tenantVerification";

export default function useTenantVerificationMissing(enabled = true) {
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    if (!enabled) { setMissing(false); return; }
    const controller = new AbortController();
    const check = () => getTenantVerification(controller.signal).then(data => {
      if (!controller.signal.aborted) setMissing(data?.status === "rejected" || data == null || (typeof data === "object" && Object.keys(data).length === 0));
    }).catch(() => { if (!controller.signal.aborted) setMissing(false); });
    check();
    window.addEventListener("tenant-verification-updated", check);
    window.addEventListener("focus", check);
    return () => {
      controller.abort();
      window.removeEventListener("tenant-verification-updated", check);
      window.removeEventListener("focus", check);
    };
  }, [enabled]);
  return missing;
}
